import React from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter, Link } from 'react-router-dom';

const ListItemDroneInventoryGeneral = (props) => {
    return (
        <Link
            style={{ display: 'block' }}
            to={props.route}
            onClick={(event) => {
                if (props.onSelectChange) {
                    props.onSelectChange(event);
                }
            }}
        >
            <span className="title sixth-text-color">
                <i className="mdi mdi-text-box-check-outline" /> {props.data.lotItemNumber}
            </span>
            <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                <i className="mdi mdi-map-marker-radius-outline" /> {props.data.location}
            </span>
            <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                <i className="mdi mdi-image-filter-center-focus" /> {props.data.cim}
            </span>
        </Link>
    );
};

export default withRouter(withTranslation()(ListItemDroneInventoryGeneral));
